<div *ngIf="submissionError" class="error-alert">
  <div class="alert-icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M11.4602 0.146447C11.3664 0.0526784 11.2392 0 11.1066 0H4.8934C4.76079 0 4.63361 0.0526784 4.53984 0.146447L0.146447 4.53984C0.0526784 4.63361 0 4.76079 0 4.8934V11.1066C0 11.2392 0.0526784 11.3664 0.146447 11.4602L4.53984 15.8536C4.63361 15.9473 4.76079 16 4.8934 16H11.1066C11.2392 16 11.3664 15.9473 11.4602 15.8536L15.8536 11.4602C15.9473 11.3664 16 11.2392 16 11.1066V4.8934C16 4.76079 15.9473 4.63361 15.8536 4.53984L11.4602 0.146447ZM8 4C8.53541 4 8.95377 4.46228 8.9005 4.99504L8.54975 8.50248C8.52151 8.78492 8.28384 9 8 9C7.71616 9 7.47849 8.78492 7.45025 8.50248L7.0995 4.99504C7.04623 4.46229 7.46459 4 8 4ZM8.00154 10C8.55383 10 9.00154 10.4477 9.00154 11C9.00154 11.5523 8.55383 12 8.00154 12C7.44926 12 7.00154 11.5523 7.00154 11C7.00154 10.4477 7.44926 10 8.00154 10Z"
        fill="#B3261E" />
    </svg>
  </div>
 
  <div class="alert-message"><b>Submission Failed:</b>
    There was a problem submitting your RFQ<br>
    <b>{{submissionError}}</b></div>
    
  <div class="alert-close" (click)="closeAlert()">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M3.21967 4.28033C2.92678 3.98744 2.92678 3.51256 3.21967 3.21967C3.51256 2.92678 3.98744 2.92678 4.28033 3.21967L12 10.9393L19.7197 3.21967C20.0126 2.92678 20.4874 2.92678 20.7803 3.21967C21.0732 3.51256 21.0732 3.98744 20.7803 4.28033L13.0607 12L20.7803 19.7197C21.0732 20.0126 21.0732 20.4874 20.7803 20.7803C20.4874 21.0732 20.0126 21.0732 19.7197 20.7803L12 13.0607L4.28033 20.7803C3.98744 21.0732 3.51256 21.0732 3.21967 20.7803C2.92678 20.4874 2.92678 20.0126 3.21967 19.7197L10.9393 12L3.21967 4.28033Z"
        fill="#212A37" />
    </svg>
  </div>
</div>
<div class="review-summary-container">
  <div class="rfq-header-container">
    <h3>{{rfqData?.rfqDetails?.rfqName}}</h3>
    <a href="javascript:void(0)" (click)="goBackToRfqParts()">Back to Add Parts</a>
  </div>
  <!-- Loading Spinner Overlay -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="spinner"></div>
    <div class="loading-text">Submitting RFQ...</div>
  </div>

  <div class="content-container" [class.blur-content]="loading">
    <!-- Left Section: Parts Table -->
    <div class="parts-list-section">
      <div class="part-card" *ngFor="let part of rfqData?.partDetails">
        <!-- Part ID: {{part.rfqPartId}} -->
        <div class="part-image">
          <div class="image-placeholder">
            <img src="assets/img/part-image.png" alt="Part Image">
          </div>
          <div class="part-title">
            <strong>{{part.partName}}</strong><br />
            <small>{{part.partNumber}}</small>
          </div>
        </div>
        <div class="part-details">
          <div>
            <div class="part-detail-item"><strong>Quantity</strong> <span class="text-truncate">{{part.quantity}}</span>
            </div>
            <div class="part-detail-item"><strong>Material</strong> <span class="text-truncate">{{part.material}}</span>
            </div>
            <div class="part-detail-item"><strong>Grade</strong> <span
                class="text-truncate">{{part.materialGrade || '-'}}</span></div>
          </div>
        </div>
        <div class="part-details">
          <div>
            <div class="part-detail-item"><strong>Finish</strong> <span class="text-truncate">{{part.finishes && part.finishes.length > 0 ?
                part.finishes.join(', ') : '-'}}</span></div>
            <div class="part-detail-item"><strong>Tolerance</strong> <span
                class="text-truncate">{{part.tolerance}}</span></div>
            <div class="drawing-model-files">
              <div class="file-label" [class.attached]="hasModelFile(part)">
                <strong>Model File</strong>
                <span *ngIf="hasModelFile(part)" class="file-check"> 
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M9.55237 2.97725C9.76915 2.75758 10.1206 2.75758 10.3374 2.97725C10.5515 3.19423 10.5542 3.54436 10.3453 3.7646L5.91018 9.0073C5.90592 9.0127 5.90136 9.01786 5.89654 9.02275C5.67975 9.24242 5.32828 9.24242 5.11149 9.02275L2.41259 6.28791C2.1958 6.06824 2.1958 5.71209 2.41259 5.49242C2.62937 5.27275 2.98085 5.27275 3.19763 5.49242L5.48729 7.81256L9.53764 2.99408C9.54222 2.98818 9.54713 2.98256 9.55237 2.97725Z" fill="#0A0F15"/>
                    </svg>
                </span>
                <span *ngIf="!hasModelFile(part)" class="file-x"> 
                  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                    <path d="M1.20738 1.60512C1.09754 1.49529 1.09754 1.31721 1.20738 1.20738C1.31721 1.09754 1.49529 1.09754 1.60512 1.20738L4.5 4.10225L7.39488 1.20738C7.50471 1.09754 7.68279 1.09754 7.79262 1.20738C7.90246 1.31721 7.90246 1.49529 7.79262 1.60512L4.89775 4.5L7.79262 7.39488C7.90246 7.50471 7.90246 7.68279 7.79262 7.79262C7.68279 7.90246 7.50471 7.90246 7.39488 7.79262L4.5 4.89775L1.60512 7.79262C1.49529 7.90246 1.31721 7.90246 1.20738 7.79262C1.09754 7.68279 1.09754 7.50471 1.20738 7.39488L4.10225 4.5L1.20738 1.60512Z" fill="#0A0F15" stroke="#0A0F15" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>  
                </span>
              </div>
              <div class="file-label" [class.attached]="hasDrawingFile(part)">
                <strong>Drawing File</strong>
                <span *ngIf="hasDrawingFile(part)" class="file-check"> 
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M9.55237 2.97725C9.76915 2.75758 10.1206 2.75758 10.3374 2.97725C10.5515 3.19423 10.5542 3.54436 10.3453 3.7646L5.91018 9.0073C5.90592 9.0127 5.90136 9.01786 5.89654 9.02275C5.67975 9.24242 5.32828 9.24242 5.11149 9.02275L2.41259 6.28791C2.1958 6.06824 2.1958 5.71209 2.41259 5.49242C2.62937 5.27275 2.98085 5.27275 3.19763 5.49242L5.48729 7.81256L9.53764 2.99408C9.54222 2.98818 9.54713 2.98256 9.55237 2.97725Z" fill="#0A0F15"/>
                    </svg>
                </span>
                <span *ngIf="!hasDrawingFile(part)" class="file-x"> 
                  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                    <path d="M1.20738 1.60512C1.09754 1.49529 1.09754 1.31721 1.20738 1.20738C1.31721 1.09754 1.49529 1.09754 1.60512 1.20738L4.5 4.10225L7.39488 1.20738C7.50471 1.09754 7.68279 1.09754 7.79262 1.20738C7.90246 1.31721 7.90246 1.49529 7.79262 1.60512L4.89775 4.5L7.79262 7.39488C7.90246 7.50471 7.90246 7.68279 7.79262 7.79262C7.68279 7.90246 7.50471 7.90246 7.39488 7.79262L4.5 4.89775L1.60512 7.79262C1.49529 7.90246 1.31721 7.90246 1.20738 7.79262C1.09754 7.68279 1.09754 7.50471 1.20738 7.39488L4.10225 4.5L1.20738 1.60512Z" fill="#0A0F15" stroke="#0A0F15" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>  
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="edit-button-container">
          <div class="edit-button" (click)="goBackToParts(part)">
            <a href="javascript:void(0)"><img src="assets/img/svg/pencil-white.svg" alt="Edit"></a>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Section: RFQ Summary -->
    <div class="rfq-summary-section">
      <h2>RFQ Summary</h2>

      <!-- Contact Details Section (New) -->
      <div class="summary-item">
        <div class="summary-label contact-details-label">Contact Details</div>
        <div class="summary-value contact-details">
          <div *ngIf="rfqData?.rfqDetails?.fullName">{{rfqData?.rfqDetails?.fullName}}</div>
          <div *ngIf="rfqData?.rfqDetails?.companyName">{{rfqData?.rfqDetails?.companyName}}</div>
          <div *ngIf="rfqData?.rfqDetails?.email">{{rfqData?.rfqDetails?.email}}</div>
          <div *ngIf="rfqData?.rfqDetails?.phoneNo">{{rfqData?.rfqDetails?.phoneNo | phoneFormat}}</div>
        </div>
      </div>
      <div class="summary-item-container">
        <div class="summary-item date-item">
          <div class="summary-label">Quote By</div>
          <div class="summary-value">{{rfqData?.rfqDetails?.quoteBy | date: 'MM/dd/yyyy'}}</div>
        </div>
        <div class="summary-item date-item">
          <div class="summary-label">Deliver By</div>
          <div class="summary-value">{{rfqData?.rfqDetails?.deliverBy | date: 'MM/dd/yyyy'}}</div>
        </div>
      </div>

      <div class="summary-item">
        <div class="summary-label">Ship Address</div>
        <div class="summary-value">
          {{rfqData?.rfqDetails?.address1}}
          <span *ngIf="rfqData?.rfqDetails?.address2">{{rfqData?.rfqDetails?.address2}}<br></span>
          {{rfqData?.rfqDetails?.city}}, {{rfqData?.rfqDetails?.state}} {{rfqData?.rfqDetails?.zip}}<br>
          {{rfqData?.rfqDetails?.country}}
        </div>
      </div>

      <div class="summary-item">
        <div class="summary-label">Industry</div>
        <div class="summary-value">{{rfqData?.rfqDetails?.industry}}</div>
      </div>

      <div class="summary-item">
        <div class="summary-label">Certificate and Qualifications</div>
        <div class="summary-value">{{ formatCertificateList() }}</div>
      </div>

      <div class="summary-item">
        <div class="summary-label">Inspection</div>
        <div class="summary-value">{{rfqData?.rfqDetails?.inspection?.length ? rfqData?.rfqDetails?.inspection?.join(', ') : '-'}}</div>
      </div>

      <div class="summary-item">
        <div class="summary-label">Payment Terms</div>
        <div class="summary-value">{{rfqData?.rfqDetails?.paymentTerms}}</div>
      </div>
    </div>
  </div>

  <div class="footer">
    <button class="submit-btn" (click)="submitRfq()">Submit RFQ</button>
  </div>
</div>